module.exports = __webpack_public_path__ + "img/copy.783df18b.svg";